import React from "react";
import {Link} from "react-router-dom";
import logoImg from "../assets/logo.png";

export default function Footer() {
    const SocialIcon = ({icon, href = "#"}) => (
        <a
            href={href}
            className="w-10 h-10 rounded-full bg-white bg-opacity-10 flex items-center justify-center hover:bg-opacity-20 transition"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i data-feather={icon}></i>
        </a>
    );

    return (
        <footer dir="rtl" style={wrap}>
            <div style={bgBlur} aria-hidden/>

            <div style={container}>
                {/* Top Section */}
                <div style={topRow}>
                    {/* Brand */}
                    <div style={{minWidth: 220}}>
                        <div style={brandRow}>
              <span style={brandMark}>
                <img
                    src={logoImg}
                    alt="استودیو مدریک"
                    style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        display: "block",
                    }}
                />
              </span>
                            <span style={{fontWeight: 900}}>مدریک استور</span>
                        </div>
                        <p style={muted}>
                            خرید سریع و امن آیتم‌های درون‌بازی. پشتیبانی واقعی و ارسال فوری.
                        </p>
                    </div>

                    {/* Navigation */}
                    <nav style={linksWrap}>
                        <div>
                            <div style={head}>فروشگاه</div>
                            <ul style={ul}>
                                <li><Link to="#" style={a}>بسته‌ها</Link></li>
                                <li><Link to="#" style={a}>پرفروش‌ها</Link></li>
                                <li><Link to="#" style={a}>تخفیف‌ها</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div style={head}>صفحات</div>
                            <ul style={ul}>
                                <li><Link to="/" style={a}>صفحه اصلی</Link></li>
                                <li><Link to="/about" style={a}>درباره ما</Link></li>
                                <li><Link to="/contact" style={a}>تماس</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div style={head}>قوانین</div>
                            <ul style={ul}>
                                <li><Link to="../pages/privacypolicy" style={a}>حریم خصوصی</Link></li>
                                <li><Link to="#" style={a}>شرایط استفاده</Link></li>
                                <li><Link to="#" style={a}>بازگشت وجه</Link></li>
                            </ul>
                        </div>
                    </nav>

                    {/* Newsletter */}
                    <form onSubmit={(e) => e.preventDefault()} style={newsletter}>
                        <div style={{fontWeight: 800, marginBottom: 8}}>خبرنامه</div>
                        <div style={inputRow}>
                            <input type="email" placeholder="ایمیل شما" style={input}/>
                            <button style={btn}>عضویت</button>
                        </div>
                        <div style={{...muted, fontSize: 12, marginTop: 6}}>
                            اسپم نمی‌فرستیم. هر زمان خواستید لغو کنید.
                        </div>
                    </form>
                </div>

                <div style={divider}/>

                {/* Bottom Section */}
                <div style={bottomRow}>
                    <div
                        style={{
                            display: "flex",
                            gap: 12,
                            alignItems: "center",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        <SocialIcon icon="twitter" href="#"/>
                        <SocialIcon icon="instagram" href="#"/>
                        <SocialIcon icon="facebook" href="#"/>
                        <SocialIcon icon="linkedin" href="#"/>
                    </div>

                    <div
                        style={{
                            ...muted,
                            fontSize: 13,
                            textAlign: "center",
                            width: "100%",
                            marginTop: 10,
                        }}
                    >
                        کلیه حقوق مادی و معنوی محصولات متعلق به استودیو بازی‌سازی مدریک است.
                    </div>
                </div>
            </div>
        </footer>
    );
}

// Base styles
const wrap = {
    position: "relative",
    marginTop: 28,
    borderTop: "1px solid #e6edf3",
    background: "#fff",
};

const container = {
    maxWidth: 1160,
    margin: "0 auto",
    padding: "18px 14px 20px",
};

const bgBlur = {
    position: "absolute",
    inset: 0,
    background:
        "radial-gradient(180px 80px at 10% 10%, rgba(37,99,235,.08), transparent 60%), radial-gradient(220px 100px at 90% 20%, rgba(34,197,94,.08), transparent 60%)",
    pointerEvents: "none",
};

const topRow = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 24,
    alignItems: "flex-start",
};

const brandRow = {display: "flex", alignItems: "center", gap: 10, marginBottom: 6};
const brandMark = {width: 40, height: 40, display: "grid", placeItems: "center", borderRadius: 10};
const linksWrap = {display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))", gap: 14};
const head = {fontWeight: 900, marginBottom: 8};
const ul = {listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 6};
const a = {color: "#475569", textDecoration: "none"};
const muted = {color: "#64748b"};

const newsletter = {
    background: "#f8fafc",
    border: "1px solid #e6edf3",
    borderRadius: 12,
    padding: 12,
    minWidth: 240,
};

const inputRow = {display: "flex", gap: 8, flexWrap: "wrap"};
const input = {
    flex: 1,
    padding: "8px 10px",
    borderRadius: 10,
    border: "1px solid #cbd5e1",
    outline: "none",
    minWidth: "150px",
};
const btn = {
    background: "#22c55e",
    color: "#fff",
    border: "1px solid #16a34a",
    borderRadius: 10,
    padding: "8px 12px",
    fontWeight: 800,
    cursor: "pointer",
    whiteSpace: "nowrap",
};
const divider = {height: 1, background: "#e6edf3", margin: "16px 0"};
const bottomRow = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 12,
};
